const actions = {
    GET_EXCEEDING_SPEED_BY_VEHICLE_ID: "vehicles/GET_EXCEEDING_SPEED_BY_VEHICLE_ID",
    SET_EXCEEDING_SPEED_BY_VEHICLE_ID: "vehicles/SET_EXCEEDING_SPEED_BY_VEHICLE_ID",

    GET_EXCEEDING_SPEED_BY_DRIVER_ID: "vehicles/GET_EXCEEDING_SPEED_BY_DRIVER_ID",
    SET_EXCEEDING_SPEED_BY_DRIVER_ID: "vehicles/SET_EXCEEDING_SPEED_BY_DRIVER_ID",

    GET_EXCEEDING_RPM_BY_VEHICLE_ID: "vehicles/GET_EXCEEDING_RPM_BY_VEHICLE_ID",
    SET_EXCEEDING_RPM_BY_VEHICLE_ID: "vehicles/SET_EXCEEDING_RPM_BY_VEHICLE_ID",

    GET_EXCEEDING_RPM_BY_DRIVER_ID: "vehicles/GET_EXCEEDING_RPM_BY_DRIVER_ID",
    SET_EXCEEDING_RPM_BY_DRIVER_ID: "vehicles/SET_EXCEEDING_RPM_BY_DRIVER_ID",

    GET_DRIVER_STATS: "vehicles/GET_DRIVER_STATS",
    SET_DRIVER_STATS: "vehicles/SET_DRIVER_STATS",

    GET_IGNITION_ON_SPEED_BY_VEHICLE_ID: 'vehicles/GET_IGNITION_ON_SPEED_BY_VEHICLE_ID',
    SET_IGNITION_ON_SPEED_BY_VEHICLE_ID: 'vehicles/SET_IGNITION_ON_SPEED_BY_VEHICLE_ID',

    GET_IGNITION_ON_RPM_BY_VEHICLE_ID: 'vehicles/GET_IGNITION_ON_RPM_BY_VEHICLE_ID',
    SET_IGNITION_ON_RPM_BY_VEHICLE_ID: 'vehicles/SET_IGNITION_ON_RPM_BY_VEHICLE_ID',
};

export default actions